import gql from "graphql-tag";

export const REGISTER_PHOTO_UPLOADS = gql`
    mutation photoUpload($filenames: [String!], $photoShootId: ID) {
        photoUpload(filenames: $filenames, photoShootId: $photoShootId) {
            errors {
                filename
                reason
            }
            uploads {
                id
                url
                filename
            }
        }
    }
`;

export const REPORT_AWS_PHOTO_UPLOAD_RESULT = gql`
    mutation photoUploadFinishedNotification(
        $id: ID!
        $result: PhotoUploadResult!
    ) {
        photoUploadFinishedNotification(photoUploadId: $id, result: $result) {
            ok
            error
        }
    }
`;

export const REGISTER_RELEASE_UPLOAD = gql`
    mutation photoReleaseUpload($filenames: [String!]) {
        photoReleaseUpload(filenames: $filenames) {
            errors {
                filename
                reason
            }
            uploads {
                id
                url
                filename
            }
        }
    }
`;

export const SUBMIT_RELEASE = gql`
    mutation photoReleaseUploadFinishedNotification(
        $id: ID!
        $result: PhotoUploadResult!
    ) {
        photoReleaseUploadFinishedNotification(
            releaseUploadId: $id
            result: $result
        ) {
            ok
            error
        }
    }
`;
